import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

// Attach bearer token as fallback when cookies are blocked (Safari cross-site)
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("zr_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

export function resolveAssetUrl(url) {
    if (!url) return "";
    if (url.startsWith("http://") || url.startsWith("https://")) return url;
    if (url.startsWith("/api/")) return `${process.env.REACT_APP_BACKEND_URL}${url}`;
    return url;
}
